import React, { useState } from 'react';

import ModalComponent from '../../../../common-components/ModalComponent/ModalComponent';
import ButtonComponent from '../../../../common-components/ButtonComponent/ButtonComponent';
import { TaskAlt as TickIcon, ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import '../../styles/addon-modal.scss';
import Gleap from 'gleap';
import { GLEAP_UPGRADE_ACCOUNT_FORM_KEY } from '@/utils/ts/gleap';

export default function AddonModal({ show, onClose, getOnModalClick }) {
  return (
    <>
      <ModalComponent show={show} width={400} onClose={onClose}>
        <div className="addon-modal">
          <h2>Get the social listening add-on!</h2>
          <p className="addon-modal-desc">
            Auto-track Posts, Request UGC Rights, Store And Manage Your Creatives Professionally.
          </p>
          <p className="addon-modal-price">
            <span
              style={{
                fontWeight: '600',
                color: 'var(--saral-purple)',
                marginRight: '5px',
              }}>
              $199
            </span>
            <span
              style={{
                fontSize: '18px',
              }}>
              /month
            </span>
          </p>
          <ButtonComponent style={{ width: '100%', margin: '20px 0' }} onClick={getOnModalClick}>
            Get Add On
          </ButtonComponent>
          <ul>
            <li>
              <TickIcon />
              Track on TikTok, Instagram, Youtube
            </li>
            <li>
              <TickIcon />
              Unlimited Posts, Unlimited Social Profiles
            </li>
            <li>
              <TickIcon />
              Request Usage Rights Seamlessly
            </li>
            <li>
              <TickIcon />
              See How Content Impacts Sales
            </li>
            <li>
              <TickIcon />
              Organize Content into Libraries
            </li>
          </ul>
          <ButtonComponent
            style={{
              width: '100%',
              padding: '8px',
            }}
            variant="secondary-outline"
            onClick={() => {
              Gleap.setTicketAttribute('Intent', 'I have more questions about the social listening add-on. Can you help?');
              Gleap.startClassicForm(GLEAP_UPGRADE_ACCOUNT_FORM_KEY, true);
              onClose();
            }}>
            I have more questions
            <ArrowForwardIcon />
          </ButtonComponent>
        </div>
      </ModalComponent>
    </>
  );
}
